/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ArrowUp: -7,
  ArrowDown: 7,
  ArrowLeft: -1,
  ArrowRight: 1,
  PageUp: function PageUp(mom) {
    return mom.add(-1, 'month');
  },
  PageDown: function PageDown(mom) {
    return mom.add(1, 'month');
  },
  Home: function Home(mom) {
    return mom.startOf('month');
  },
  End: function End(mom) {
    return mom.endOf('month');
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/MonthView/navKeys.js
// module id = 233
// module chunks = 0